//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TabListChart',
  props: {
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      animateUp: false,
      timer: null
    };
  },
  methods: {
    scrollAnimate: function scrollAnimate() {
      var _this = this;
      // 超出范围在后再进行滚动
      if (this.tableData.length >= 5) {
        this.timer = setInterval(function () {
          _this.animateUp = true;
          setTimeout(function () {
            _this.tableData.push(_this.tableData[0]);
            _this.tableData.shift();
            _this.animateUp = false;
          }, 500);
        }, 3000);
      }
    },
    // 鼠标移上去停止
    stop: function stop() {
      clearInterval(this.timer);
    },
    // 鼠标离开继续滚动
    up: function up() {
      this.scrollAnimate();
    },
    destroyed: function destroyed() {
      clearInterval(this.timer);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};